export interface IExcelExportIdentifierListItem {
    id: string;
    name: string;
}

export class ExcelExportIdentifierListItem implements IExcelExportIdentifierListItem {
    public id: string;
    public name: string;
    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IExcelExportIdentifierListItem);
    constructor(obj?: any) {
        this.id = (obj && obj.id) || '';
        this.name = (obj && obj.name) || '';
    }
}
